<script lang="ts">
    export let width: string | number = 16;
    export let height: string | number = 16;
    export let title = "";
    export let color = "";
    export let stroke = "";
    export let className: string | null = null;
    export { className as class };
    export let viewBox: string | null = "0 0 20 20";

    export let ariaHidden = true;
</script>

<svg
    class={className}
    xmlns="http://www.w3.org/2000/svg"
    {width}
    {height}
    {viewBox}
    aria-labelledby={title}
    aria-hidden={ariaHidden}
    role="presentation"
    fill="none"
>
    {#if title}
        <title id={title} lang="en">{title}</title>
    {/if}
    <g {stroke} fill={color || "currentColor"}>
        <slot />
    </g>
</svg>
